import { Component, OnInit, NgZone, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, ViewRef } from '@angular/core';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_material from "@amcharts/amcharts4/themes/material";
import { ChartsService } from '../charts-service/charts.service';
import { QueryParamsModel, LayoutUtilsService } from 'app/core/_base/crud';
import moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { DungChungService } from '../../dung-chung/__services/dung-chung.service';
import { CommonConFig } from '../../dung-chung/__model/common_config.model';
am4core.useTheme(am4themes_material);
@Component({
  selector: 'kt-ket-qua-san-xuat',
  templateUrl: './ket-qua-san-xuat.component.html',
  styleUrls: ['./ket-qua-san-xuat.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DatePipe]
})
export class KetQuaSanXuatComponent implements OnInit {

  chartPie: am4charts.PieChart;
  CONFIG: CommonConFig;
  TuNgay;
  DenNgay;
  chart: am4charts.XYChart;
  xAxis: am4charts.CategoryAxis;
  yAxis: am4charts.ValueAxis;
  config = {
  }
  constructor(
    private zone: NgZone,
    private chartsservice: ChartsService,
    private changeDetect: ChangeDetectorRef,
    private DungChungService: DungChungService,
    private layoutUtilsService: LayoutUtilsService,
  ) {

  }
  ngAfterViewInit(): void {

    // this.loadBieuDo();
  }


  ngOnDestroy() {

  }
  ngOnInit() {
    this.CONFIG = new CommonConFig();
    this.configchart();
    this.chartsservice.KetQuaSanXuat().subscribe(res => {
      this.chart.data = res.data;
      this.createSeries('first', 'Kế hoạch hôm nay');
      this.createSeries('second', 'Thực tế hôm nay');
      this.changeDetectView();
    });
    
  }
  changeDetectView() {
    if (!(this.changeDetect as ViewRef).destroyed) {
      this.changeDetect.detectChanges()
    }
  }




  configchart() {

    this.chart = am4core.create('chartXYketqua', am4charts.XYChart)
    this.chart.colors.step = 2;

    this.chart.legend = new am4charts.Legend()
    this.chart.legend.position = 'top'
    this.chart.legend.paddingBottom = 20
    this.chart.legend.labels.template.maxWidth = 95

    this.xAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
    this.xAxis.dataFields.category = 'category'
    this.xAxis.renderer.cellStartLocation = 0.1
    this.xAxis.renderer.cellEndLocation = 0.9
    this.xAxis.renderer.grid.template.location = 0;

    this.yAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
    this.yAxis.min = 0;
  }


  createSeries(value, name) {
    let series = this.chart.series.push(new am4charts.ColumnSeries())
    series.dataFields.valueY = value
    series.dataFields.categoryX = 'category'
    series.name = name

    let bullet = series.bullets.push(new am4charts.LabelBullet())
    bullet.interactionsEnabled = false
    bullet.dy = 30;
    bullet.label.text = '{valueY}'
    bullet.label.fill = am4core.color('#ffffff')

    return series;
  }
}